import { HighlightIcon, SkeletonText } from '@dev-spendesk/grapes';

import { useTranslation } from 'src/core/common/hooks/useTranslation';

import { useAccountingSoftwareName } from '../../apis';

export const NoOptions = ({
  isFieldSelector,
}: {
  isFieldSelector?: boolean;
}) => {
  const { t } = useTranslation('global');
  const { accountingSoftwareName, isLoading } = useAccountingSoftwareName();

  return (
    <div className="flex flex-col items-center justify-center gap-16 px-16">
      <div>
        <HighlightIcon name="circle-information" variant="info" size={32} />
      </div>
      <div>
        {isLoading ? (
          <SkeletonText />
        ) : (
          <p className="body-m text-content-primary text-center">
            {isFieldSelector
              ? t(
                  'bookkeep.integrations.settings.analyticalFieldMapping.configurationPage.noFieldOptions',
                  { integration: accountingSoftwareName },
                )
              : t(
                  'bookkeep.integrations.settings.analyticalFieldMapping.configurationPage.noOptions',
                  { integration: accountingSoftwareName },
                )}
          </p>
        )}
      </div>
    </div>
  );
};
